/**
 * Product gallery Owl Carousel - mobile only (max-width: 749px).
 * Syncs to variant featured image when variant changes (e.g. Menthol/Regular).
 */
(function () {
  const MOBILE_BREAKPOINT = 749;
  const VARIANT_CHANGE_EVENT = 'variant-change';
  var page = document.querySelector('.product-gallery-desktop');

  console.log(page);

  function isMobile() {
    return window.innerWidth <= MOBILE_BREAKPOINT;
  }

  function initOwl(el) {
    if (typeof window.jQuery === 'undefined' || !window.jQuery.fn.owlCarousel) return;
    var $el = window.jQuery(el);
    if ($el.data('owl.carousel')) return;
    $el.owlCarousel({
      items: 1,
      margin: 10,
      loop: true,
      nav: false,
      dots: true,
      dotsEach: 1,
      responsive: {
        0: {
          items: 1.1,
          margin: 8,
        },
      },
    });
  }

  function destroyOwl(el) {
    var $el = window.jQuery(el);
    if (!$el.data('owl.carousel')) return;
    try {
      $el.trigger('destroy.owl.carousel');
    } catch (e) {}
    $el.removeClass('owl-loaded owl-drag').removeData('owl.carousel');
  }

  function goToMediaSlide(mediaId) {
    if (!mediaId || !isMobile()) return;
    var carousel = document.querySelector('.product-gallery-owl');
    if (!carousel || !window.jQuery || !window.jQuery(carousel).data('owl.carousel')) return;
    var $owl = window.jQuery(carousel);
    var $target = $owl.find('[data-media-id="' + mediaId + '"]').first();
    if (!$target.length) return;
    var $owlItem = $target.closest('.owl-item');
    if (!$owlItem.length) return;
    var index = $owlItem.index();
    if (index < 0) return;
    $owl.trigger('to.owl.carousel', index, 300);
  }

  /**
   * Update mobile Owl gallery from fetched section HTML (same as desktop).
   * Puts variant's featured image first and re-inits Owl so every variant shows its featured image.
   */
  function updateMobileGalleryFromHtml(sectionId, html) {
    if (!html || !html.querySelector || !isMobile()) return;
    var newOwlEl = html.querySelector('.product-gallery-mobile .product-gallery-owl');
    if (!newOwlEl) return;
    var productInfo = document.querySelector('#MainProduct-' + sectionId) || document.querySelector('[data-section="' + sectionId + '"]');
    if (!productInfo) return;
    var currentOwl = productInfo.querySelector('.product-gallery-owl');
    if (!currentOwl) return;
    if (window.jQuery && window.jQuery(currentOwl).data('owl.carousel')) {
      destroyOwl(currentOwl);
    }
    currentOwl.innerHTML = newOwlEl.innerHTML;
    var newCount = newOwlEl.getAttribute('data-media-count');
    if (newCount != null) currentOwl.setAttribute('data-media-count', newCount);
    initOwl(currentOwl);
    if (window.jQuery(currentOwl).data('owl.carousel')) {
      window.jQuery(currentOwl).trigger('to.owl.carousel', 0, 300);
    }
  }

  function onVariantChange(payload) {
    if (!payload || !payload.data) return;
    var data = payload.data;
    var variant = data.variant;
    var sectionId = data.sectionId;
    var html = data.html;
    if (html && sectionId) {
      updateMobileGalleryFromHtml(sectionId, html);
    } else if (variant && variant.featured_media && variant.featured_media.id && sectionId) {
      var mediaId = sectionId + '-' + variant.featured_media.id;
      goToMediaSlide(mediaId);
    }
  }

  function syncAll() {
    document.querySelectorAll('.product-gallery-owl').forEach(function (el) {
      var count = parseInt(el.getAttribute('data-media-count') || '0', 10);
      if (count < 2) return;
      if (isMobile()) initOwl(el);
      else destroyOwl(el);
    });
  }

  function run() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', runAfterLoad);
    } else {
      runAfterLoad();
    }
    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(syncAll, 150);
    });
    document.addEventListener('shopify:section:load', syncAll);
  }

  function runAfterLoad() {
    syncAll();
    if (typeof subscribe === 'function') {
      subscribe(VARIANT_CHANGE_EVENT, onVariantChange);
    } else {
      document.addEventListener(VARIANT_CHANGE_EVENT, function (e) {
        onVariantChange(e.detail || e);
      });
    }
  }

  run();
})();
